import MaintenanceIllustration from '@/components/SpotIllustration/MaintenanceIllustration'
import { RawButton } from '@/components/Button'
import styles from './TechnicalBreakPage.module.css'

export interface TechnicalBreakPageProps {
  onRefresh: () => void
}

/**
 * Shown instead of the app while the backends are down.
 */
export function TechnicalBreakPage({ onRefresh }: TechnicalBreakPageProps) {
  return (
    <div className={styles.root}>
      <MaintenanceIllustration className={styles.illustration} />
      <div className={styles.text}>
        <h1 className={styles.title}>Sorry, we're under maintenance!</h1>
        <p className={styles.subtitle}>
          We'll be back soon.
          <br />
          You may also refresh the page or try again later.
        </p>
      </div>
      <RawButton className={styles.button} onPress={onRefresh}>
        REFRESH
      </RawButton>
    </div>
  )
}
